import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const updateBankDetail = React.createContext({});
export let updateBankDetailMachine: any;

const MODULE_NAME = 'machines.updateBankDetail';

export const useSMUpdateBankDetail = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  updateBankDetailMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(updateBankDetailMachine);

  return {
    updateBankDetailMachine,
    updateBankDetailState: state,
    updateBankDetailSend: send,
  };
};
